import { BasePageItemsClient, HomeDataSection, ProductShelvesSection, ProductShelvesPayloadSection, HomeDataPayloadSection } from "@core/types";
import { convertHomeData } from "./converters";

class PageItemsClient extends BasePageItemsClient {
  async getPageItemById(id: string): Promise<ProductShelvesSection | null> {
    const { data } = await this.instance.get<ProductShelvesPayloadSection>(`/wp-json/parhato-api/v1/get-page-item?id=${id}`);
    return data ? convertHomeData(data) as ProductShelvesSection : null;
  }

  async getHome(): Promise<HomeDataSection[] | null> {
    const { data } = await this.instance.get<HomeDataPayloadSection[]>("/wp-json/parhato-api/get-home");

    return data?.length ? data.map((item) => convertHomeData(item)) : null;
  }
}

export default PageItemsClient;
